import styles from "./PersonInfo.module.scss";
import { useHistory } from "react-router";

import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";

export default function PersonInfo() {
  const history = useHistory();
  {
    /* Bayad Inja Meghdare RulesAccept Check Shavad Dar Gheyre in surate Redirect mishe be
    Authentication, alave bar un check mishavad ke agar data ha por shode bud redirect beshe
    Be Authentication,
    Baraye ravand behtar lazem ast hameye field ha por shavad va data ba'ad az un send she.
    */
  }
  {
    /*Ba'ad az ersal etelaat, dar surate taeed history replace mishe ba authentication va data haye jadid
unja load mishe */
  }
  return (
    <section className={styles.container}>
      <header>
        <div className={styles.back}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.push("/my-profile/authentication")}
          />
        </div>
        <div className={styles.header_title}>اطلاعات فردی</div>
      </header>
      <form onSubmit={() => alert("SALAM DADA")}>
        <main className={styles.container_of_inputs}>
          <input type="text" placeholder="نام" />
          <div className={styles.error_container}>
            تعداد کاراکتر کمتر از 2 تا نباید باشد
          </div>
          <input type="text" placeholder="نام خانوادگی" />
          <input type="number" placeholder="کد ملی" />
          <input type="number" placeholder="شماره موبایل" />
          <input type="number" placeholder="شماره ثابت" />
          <input type="email" placeholder="ایمیل" />
          <button type="submit">تایید</button>
        </main>
      </form>
    </section>
  );
}
